export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} من {2}',
    noResultsText: 'لا توجد سجلات مطابقة',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'الصفوف لكل صفحة:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'العناصر لكل صفحة:',
    itemsPerPageAll: 'الكل',
    nextPage: 'الصفحة التالية',
    prevPage: 'الصفحة السابقة',
    firstPage: 'الصفحة الأولى',
    lastPage: 'الصفحة الأخيرة',
  },
  datePicker: {
    itemsSelected: '{0} المحدد',
  },
  noDataText: 'لا توجد بيانات متاحة',
  carousel: {
    prev: 'الصورة السابقة',
    next: 'البصري التالي',
  },
  calendar: {
    moreEvents: '{0} أكثر من',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
